import React from "react";

import Icon1 from "../../../assets/images/partnerInstitutionIcon.svg";
import Icon2 from "../../../assets/images/globeInstitutionIcon.svg";
import Icon3 from "../../../assets/images/jointInstitutionIcon.svg";
import styles from "./Banner.module.css";

export default function Banner() {
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.tag}>
          Knowledge Partners • Research Hubs • Centers of Excellence
        </div>
        <div className={styles.heroText}>
          <h1>
            <span className={styles.accent}> Institution</span>{" "}
            <span className={styles.accent2}>Membership</span>
          </h1>
          <p>
            IMPARC Institution Membership brings universities, colleges, and
            research centers into a high-impact network of knowledge exchange.
            Partners host the Knowledge Series, co-create publications and
            events, access our mentor pool, and gain national & international
            visibility through joint recognitions and outcomes.
          </p>
          <div className={styles.heroActions}>
            <div className={styles.icon}>
              <img src={Icon1} alt={"Partner Institutions"} />
              <p>
                <strong>150+</strong>
                <br />
                Partner Institutions
              </p>
            </div>
            <div className={styles.icon}>
              <img src={Icon2} alt={"Countries"} />
              <p>
                <strong>25+</strong>
                <br />
                Countries
              </p>
            </div>
            <div className={styles.icon}>
              <img src={Icon3} alt={"Joint Publications"} />
              <p>
                <strong>500+</strong>
                <br />
                Joint Publications
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
